import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-support_request",
  "use": "icon-support_request-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-support_request\">\n<path d=\"M1.5 16.5V13.1667M1.5 13.1667V3.16667C1.5 2.24619 2.24619 1.5 3.16667 1.5H8.58334L9.41667 2.33333H16.5L14 7.33333L16.5 12.3333H9.41667L8.58334 11.5H3.16667C2.24619 11.5 1.5 12.2462 1.5 13.1667ZM9 1.91667V6.5\" stroke=\"#2887EB\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol